import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useUpdateDocumentCategory } from '@area-restrita/api-client/endpoints/document-category/document-category.gen';

import { useDialog } from '@/components/template/Dialog';

import DocumentCategoryForm, {
  IDocumentCategory,
} from './document-category-form';

interface IProps {
  documentCategoryId: number;
  defaultValues: DefaultValues<IDocumentCategory>;
}

const UpdateDocumentCategory: React.FC<IProps> = ({
  documentCategoryId,
  defaultValues,
}) => {
  const { handleClose } = useDialog();
  const { mutateAsync } = useUpdateDocumentCategory();

  const onSubmit = useCallback<SubmitHandler<IDocumentCategory>>(
    (data) =>
      mutateAsync(
        { id: documentCategoryId, data },
        {
          onSuccess: () => {
            toast.success('Categoria de documento editada com sucesso');
            handleClose();
          },
          onError: () => {
            toast.error('Erro ao editar categoria de documento');
          },
        },
      ),
    [documentCategoryId, handleClose, mutateAsync],
  );

  return (
    <DocumentCategoryForm onSubmit={onSubmit} defaultValues={defaultValues} />
  );
};

export default UpdateDocumentCategory;
